import updateUserLanguage from "@casino/actions/updateUserLanguage";
import useRouter from "@casino/legacy/client/hooks/router/useRouter";
import useIsLoggedIn from "@casino/legacy/client/hooks/user/useIsLoggedIn";
import useSite from "@casino/legacy/client/hooks/useSite";
import useAppContext from "@casino/legacy/shared/context/AppContext/useAppContext";
import nativeRedirect from "@casino/legacy/shared/utils/router/nativeRedirect";
import { getCookie, setCookie } from "@workspace/cookies/browser";
import { LANGUAGE_COOKIE } from "@workspace/nextjs_utils/src/cookies/LANGUAGE_COOKIE";
import inAYear from "@workspace/nextjs_utils/src/date/inYear";
import { useCallback } from "react";
import useLanguageFeatureFlags from "./useLanguageFeatureFlags";

const useLanguageSwitcher = () => {
  const router = useRouter();
  const isLoggedIn = useIsLoggedIn();
  const { languages } = useAppContext();
  const { siteConfig } = useSite();
  const languageFlags = useLanguageFeatureFlags();
  const enabledLanguages = languages.filter(
    (lang) => languageFlags?.[lang] !== false,
  );
  const userPreferenceId = getCookie("userPreferenceId");

  const updateLang = async (value: string | Language) => {
    await updateUserLanguage({
      language: value as string,
      userPreferenceId,
    });
  };

  const inAYearMemo = useCallback(() => inAYear(), []);

  const handleChange = async (value: string) => {
    const code =
      enabledLanguages.find((lang) => lang === value) ?? siteConfig.defaultLang;

    if (isLoggedIn) {
      await updateLang(code);
    }

    setCookie(LANGUAGE_COOKIE, code, { expires: inAYearMemo() });
    nativeRedirect(router.asPath, code, router.defaultLocale);
  };

  return { handleChange, router, languages: enabledLanguages };
};

export default useLanguageSwitcher;
